module.exports = __webpack_public_path__ + "img/line-communities.b9a22145.svg";